import * as Yup from 'yup'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { CampoParametro, ValoresParametro } from '../../core/_models'

/** Um campo por parâmetro; as faixas numéricas são as mesmas do backend. */
export const parametrosSchema = <T extends ValoresParametro>(
  campos: CampoParametro<T>[],
  t: TFunction
) =>
  Yup.object(
    Object.fromEntries(
      campos.map((c) => [
        c.name,
        c.tipo === 'booleano'
          ? Yup.boolean()
          : Yup.number()
              .typeError(t('parametros.erro_numero'))
              .integer(t('parametros.erro_inteiro'))
              .min(c.min!, t('parametros.erro_faixa', { min: c.min, max: c.max }))
              .max(c.max!, t('parametros.erro_faixa', { min: c.min, max: c.max }))
              .required(t('parametros.erro_obrigatorio')),
      ])
    )
  )
